export enum ClientRoutes {
  Client = 'client',
  ClientPersonalInformation = 'client-personal-information',
  ClientProjects = 'client-projects',
  ClientSettings = 'client-settings',
}
